module.exports = __webpack_public_path__ + "static/media/earthshaker.24a342e3.png";